import React from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** Glow colour (rgba), default warm yellow-white */
  color?: string;
  /** Flicker cycle duration seconds, default 3 */
  dur?: number;
}

/**
 * LightOn — warm brightness pulse simulating a light switching on.
 * Flickers then settles to a dim glow, cycling on repeat.
 */
const LightOn: React.FC<Props> = ({
  color = "rgba(255,225,150,0.55)",
  dur = 3,
}) => (
  <div style={overlayBase}>
    <style>{`
      @keyframes oot-lighton {
        0%, 60% { opacity: 0; }
        65%      { opacity: 1; }
        75%      { opacity: 0.4; }
        80%      { opacity: 0.9; }
        100%     { opacity: 0.15; }
      }
    `}</style>
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `radial-gradient(circle at 50% 30%, ${color}, transparent 65%)`,
        animation: `oot-lighton ${dur}s ease-out infinite`,
      }}
    />
  </div>
);

export default LightOn;
